














































































import {Component, Vue} from '@/shared/component';
import {Stored} from "vue-stored-prop-decorator";
import {ResultType} from "@/shared/xhttp";

import storeUser from '@/stores/modules/user';
import CrudEssenceAchatFilterTotauxEssenceAchats
	from "@/components/Crud/EssenceAchat/FilterTotauxEssenceAchats.vue";
import CrudEssenceAchatFilterRechercheEssenceAchats
	from "@/components/Crud/EssenceAchat/FilterRechercheEssenceAchats.vue";
import CrudEssenceAchatListTotauxEssenceAchats from "@/components/Crud/EssenceAchat/ListTotauxEssenceAchats.vue";
import CrudVenteFilterTotauxVentes from "@/components/Crud/Vente/FilterTotauxVentes.vue";
import CrudVenteListTotauxVentes from "@/components/Crud/Vente/ListTotauxVentes.vue";
import CrudApprovisionnementFilterTotauxApprovisionnements from "@/components/Crud/Approvisionnement/FilterTotauxApprovisionnements.vue";
import CrudApprovisionnementListTotauxApprovisionnements from "@/components/Crud/Approvisionnement/ListTotauxApprovisionnements.vue";
import CrudEssenceAchatSyntheseEssenceAchats from "@/components/Crud/EssenceAchat/SyntheseEssenceAchats.vue";

@Component({
	components: {
		CrudEssenceAchatFilterTotauxEssenceAchats,
		CrudEssenceAchatListTotauxEssenceAchats,
		CrudVenteFilterTotauxVentes,
		CrudVenteListTotauxVentes,
		CrudApprovisionnementFilterTotauxApprovisionnements,
		CrudApprovisionnementListTotauxApprovisionnements,
		CrudEssenceAchatSyntheseEssenceAchats,
	}
})
export default class HomeView extends Vue {

	private panelSynthese : number = 0;
	private panel : number = 1;
	private panel2 : number = 1;
	private panel3 : number = 1;

	public created(): void {

		//console.log("created");
	}
	
	public mounted(): void {
		this.addEventDom(window, 'resize', () => this.$forceUpdate());

		//console.log("mounted");
	}
	
	private get chart_title(): string
	{
		return "Bois en stock";
	}
	
}
